const MESSAGE_WIDTH = /"messageWidth"\s*(?::|=>)\s*"(\d+)px"/;
const DEFAULT_MESSAGE_WIDTH = 600;
const FRAME_GUTTER = 40;
export const SAMPLE_COLUMN_WIDTH = 300;
const DRAWER_CHROME_WIDTH = 75;

export const desktopFrameWidth = (template) => {
  const match = String(template || "").match(MESSAGE_WIDTH);

  return (match ? Number(match[1]) : DEFAULT_MESSAGE_WIDTH) + FRAME_GUTTER;
};

export const previewDrawerWidth = (template, hasSampleData) => {
  const fit = desktopFrameWidth(template) + (hasSampleData ? SAMPLE_COLUMN_WIDTH : 0) + DRAWER_CHROME_WIDTH;

  return `min(${fit}px, max(100vw - var(--nav-rail-width, 0px) - 16px, min(100vw, 360px)))`;
};
